import {Checkout} from "@wwdev/webshop/checkout";
import Form from "@wwdev/forms/form";

class CustomCheckout extends Checkout {
	constructor(config = {}) {
		super(config);
		this.config = Object.assign({
			scope: '[data-checkout]',
			fields: '[data-required-for-quotation]',
			isQuotationCheck: '[name="is_quotation"]'
		}, config);
	}


	init() {
		super.init();
		this.setDataAttributes();
	}

	async _countryOptionChange(e) {
		let $target = $(e.currentTarget);
		try {
			let data = await this._updateCheckout($target);

			this.saveAddress(e);

			return data;
		} catch (e) {
			console.error(e);
		}
	}

	_addEventListeners() {
		super._addEventListeners();
		$(document).off('.checkout')
			.on('keyup.checkout', '[data-checkout] [data-ww-bind], [data-checkout] [name="email"]', this.saveAddress.bind(this))
			.on('change.checkout', '[data-checkout] #send_other_address', this.saveAddress.bind(this))
			.on('change.checkout', this.config.isQuotationCheck, this.setRequiredFields.bind(this));
	}

	saveAddress(event) {
		let $input = $(event.currentTarget);

		this.address_timeout ? clearTimeout(this.address_timeout) : null;
		this.address_timeout = setTimeout(() => {
			let form = new Form($input.closest('form')[0]);
			form.appendMany({'action': 'save_address'});
			form.post({
				success: this._onSuccessSaveAddress.bind(this)
			});
		}, 200);
	}

	_onSuccessSaveAddress(response) {
		$('[data-checkout-basket="scope"]').html(response.basket_html);
	}

	setDataAttributes() {
		this.$checkout.find(this.config.fields).each((index, element) => {
			let $input = $(element);
			if($input.attr('required') && ['required', 'true', true].includes($input.attr('required'))) {
				$input.data('required-for-order', 'true');
			} else {
				$input.data('required-for-order', 'false')
			}
		});

		this.setRequiredFields();
	}

	setRequiredFields() {
		let $check = this.$checkout.find(this.config.isQuotationCheck);
		let dataName = 'required-for-order';

		if($check.is(':checked')) {
			dataName = 'required-for-quotation';
		}

		this.$checkout.find(this.config.fields).each((index, element) => {
			let $input = $(element);

			if($input.data(dataName) && [true, 'true'].includes($input.data(dataName))) {
				$input.attr('required', true);
				console.log(`${$input.attr('name')}: true`);
			} else {
				$input.attr('required', false);
				console.log(`${$input.attr('name')}: false`);
			}
		});
	}
}

export default CustomCheckout;